import {
  IconButton,
  Badge,
  Menu,
  MenuItem,
  Avatar,
  Typography,
  Box,
  Divider,
} from "@mui/material";

import NotificationsIcon from "@mui/icons-material/Notifications";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchNotifications,
  markNotificationReadAPI
} from "../../redux/slice/NotificationSlice";

import { useNavigate } from "react-router-dom";


// ---------- time ago helper ----------
const timeAgo = (dateString) => {
  const date = new Date(dateString);
  const seconds = Math.floor((new Date() - date) / 1000);

  const intervals = [
    { label: "year", seconds: 31536000 },
    { label: "month", seconds: 2592000 },
    { label: "day", seconds: 86400 },
    { label: "hour", seconds: 3600 },
    { label: "minute", seconds: 60 },
  ];

  for (const i of intervals) {
    const count = Math.floor(seconds / i.seconds);
    if (count >= 1) {
      return `${count} ${i.label}${count > 1 ? "s" : ""} ago`;
    }
  }

  return "Just now";
};


export default function NotificationBell() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { list, unreadCount } =
    useSelector((state) => state.notifications);

  console.log('list', list) 

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);


  // ---------- OPEN MENU ----------
  const handleOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };
  
  const handleClose = () => setAnchorEl(null);
  

  // ---------- CLICK NOTIFICATION ----------
  const handleNotificationClick = async (notification) => {

    
    handleClose();
    
    if (notification.action) {
      navigate(notification.action);
    }
    // Call backend first
    await dispatch(markNotificationReadAPI(notification.id));
    // refetch notification
    dispatch(fetchNotifications());
  };


  return (
    <>
      <IconButton color="inherit" onClick={handleOpen}>
        <Badge badgeContent={unreadCount} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: 400,
            maxHeight: 420,
            borderRadius: 2,
            boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
            ml: -10,
            mt: 1.5,
          },
        }}
      >

        <Box px={2} py={1}>
          <Typography variant="body1" fontWeight={600}>
            Notifications
          </Typography>
        </Box>

        <Divider />

        {list.length === 0 && (
          <MenuItem disabled>No notifications</MenuItem>
        )}

        {list.map((n) => (

          <MenuItem
            key={n.id}
            onClick={() => handleNotificationClick(n)}
            sx={{
              alignItems: "flex-start",
              backgroundColor: n.is_read ? "inherit" : "#f5f7ff",
              position: "relative",
            }}
          >

            <Avatar sx={{ mr: 2 }}>
              {n.title?.[0]?.toUpperCase()}
            </Avatar>

            <Box>
              <Typography variant="body2" fontWeight={600}>
                {n.title}
              </Typography>

              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ whiteSpace: "pre-line" }}
              >
                {n.message}
              </Typography>

              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: "block", mt: 0.5 }}
              >
                {timeAgo(n.created_at)}
              </Typography>
            </Box>

            {!n.is_read && (
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  bgcolor: "primary.main",
                  position: "absolute",
                  right: 16,
                  top: 20,
                }}
              />
            )}

          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
